export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_24-718ff5d0a7c41a8e89bfe1e6192cb630.jpg";